import {Model} from '@vuex-orm/core';
import Ie from './Ie';

export default class Oa extends Model {
    static entity = 'oas';

    static fields () {
        return {
            id: this.number(0),
            cod: this.string(''),
            eje: this.string(''),
            cod_eje: this.string(''),
            asignatura: this.string(''),
            asignatura_id: this.number(0),
            categoria: this.string(''),
            categoria_id: this.number(0),
            prioridadOA: this.string('').nullable(),

            // compatibilidad
            selectedRows: this.attr([]), // IEs

            disabled: this.boolean(false),
            name: this.string(''),
            ies: this.hasMany(Ie, 'oa_id'),
        };
    }
}
